import { Text } from '@logz-ui/styleguide';
import { SneakPeakBanner } from 'ui/components/App/SneakPeakBanners/SneakPeakBanner';
import { dashboardsHubRouteName } from 'states/dashboards-hub/dashboards-hub.routes';

export const DashboardSneakPeakBanner = () => {
  return (
    <SneakPeakBanner
      textComponent={
        <Text>
          The Dashboards hub will soon be available exclusively in the new <b>Open 360 AI Experience</b>
        </Text>
      }
      allowedStates={[dashboardsHubRouteName]}
    />
  );
};
